import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import BasicSelect from '../../../../../shared/components/formComponents/groups/BasicSelect';
import { VerbRichTextEditor } from '../../../../../shared/components/formComponents/VerbRichTextEditor';
import RichTextNotesHeader from './RichTextNotesHeader';
import CopyAssetLink from '../../../../components/CopyAssetLink';
import ChoosePathOption from './ChoosePathOption';

const displayTypeOptions = [
    // {
    //   label: 'Radio',
    //   value: 'radio',
    // },
    // {
    //   label: 'Image',
    //   value: 'image',
    // },
    {
        label: 'Buttons',
        value: 'buttons'
    }
];

class ChooseOnePathSectionItem extends Component {
    static propTypes = {
        contentValues: PropTypes.object.isRequired,
        assetLinkOptions: PropTypes.array,
        memberReference: PropTypes.string,
        isGlobalSectionItem: PropTypes.bool,
        metadataActive: PropTypes.bool,
        changeFormValue: PropTypes.func,
        getFormValue: PropTypes.func
    };

    componentDidMount() {
        const {
            // eslint-disable-next-line react/prop-types
            contentValues: { displayType = 'boxes', options = [], description = '' } = {}
        } = this.props;
        if (options.length && !options[0].choice) {
            // options from props do not contain appropriate values, then reset them
            this.props.changeFormValue({ field: `${this.props.memberReference}.content`, value: { displayType } });
            if (description) {
                this.props.changeFormValue({
                    field: `${this.props.memberReference}.content.description`,
                    value: description
                });
            }
        }
    }

    onRoleChange = (id, val) => {
        const { changeFormValue, getFormValue } = this.props;
        const oldParticipants = getFormValue('participants');
        const roleDict = oldParticipants.reduce((acc, part) => {
            acc[part.id] = part;
            return acc;
        }, {});
        roleDict[id] = { id, type: val };
        const newParticipants = Object.values(roleDict);

        changeFormValue({ field: 'participants', value: newParticipants });
        return val;
    };

    onRoleRemoval = (id) => {
        const { changeFormValue, getFormValue } = this.props;
        const oldParticipants = getFormValue('participants');
        const roleDict = oldParticipants.reduce((acc, part) => {
            acc[part.id] = part;
            return acc;
        }, {});
        delete roleDict[id];
        const newParticipants = Object.values(roleDict);
        changeFormValue({ field: 'participants', value: newParticipants });
    };

    render() {
        const { memberReference, contentValues, isGlobalSectionItem, metadataActive = false } = this.props;
        return (
            <div className={'chooseOnePathSectionItem'}>
                <div className={'row'}>
                    <div className={'col-7'}>
                        <Field
                            name={memberReference ? `${memberReference}.content.description` : 'content.description'}
                            label={'Description'}
                            placeholder={'Enter a description'}
                            component={VerbRichTextEditor}
                            readOnly={isGlobalSectionItem}
                            rows={3}
                        />
                    </div>
                    <div className={'col-5 mt-4'}>
                        <RichTextNotesHeader />
                        <CopyAssetLink assetLinkOptions={this.props.assetLinkOptions} />
                    </div>
                </div>
                <div className={'row'}>
                    <Field
                        name={memberReference ? `${memberReference}.content.displayType` : 'content.displayType'}
                        label={'Display Type'}
                        options={displayTypeOptions}
                        component={BasicSelect}
                        disabled={isGlobalSectionItem}
                        className={'col-4 hidden'}
                    />
                </div>
                <div className={'row'}>
                    <FieldArray
                        name={memberReference ? `${memberReference}.content.options` : 'content.options'}
                        contentValues={contentValues}
                        component={ChoosePathOption}
                        metadataActive={metadataActive}
                        disabled={isGlobalSectionItem}
                        handleRoleChange={this.onRoleChange}
                        handleRoleDelete={this.onRoleRemoval}
                    />
                </div>
            </div>
        );
    }
}

export default ChooseOnePathSectionItem;
